import { render } from "./ActionSelectionPage.vue?vue&type=template&id=0c90e8d8&scoped=true"
import script from "./ActionSelectionPage.vue?vue&type=script&lang=js"
export * from "./ActionSelectionPage.vue?vue&type=script&lang=js"

import "./ActionSelectionPage.vue?vue&type=style&index=0&id=0c90e8d8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c90e8d8"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QCard,QCardSection});
